import { VF_TEXTAREA } from 'AppSrc/core/components/forms/form-base-components/v-f-textarea';
import {
  INLINE_ERRORS,
  commonValidation,
  cleanUpFieldErrors,
  getDefaultFieldErrors,
} from 'AppSrc/core/components/forms/form-base-components/utility/common-validation';

const fieldId = 'peer-rejection-reason';

const initialValues = '';

const minCharacters = 20;

const vFParams = {
  fieldTitle: `Please provide detailed reason for rejection (min. ${minCharacters} characters)`,
  characterLimit: 500, // don't forget to add to validator
  placeholder: 'Please enter text',
};



const validator = (params) => {
  const {
    values,
    field,
  } = params;
  const {
    optional,
  } = field;

  /* MAKE A DEFAULT ERRORS OBJECT */
  const errors = getDefaultFieldErrors();

  /* ERROR CHECKERS */
  const noValue = commonValidation.noValue(values[fieldId], VF_TEXTAREA);
  const overCharacterLimit = commonValidation.textInput.isOverCharacterLimit(values[fieldId], vFParams.characterLimit);
  // const hasSpecialCharacter = commonValidation.textInput.hasSpecialCharacter(values[fieldId]);
  const underCharacterMin = commonValidation.textInput.isUnderCharacterMinimum(values[fieldId], minCharacters);


  /* ADD ERRORS TO ERROR OBJECT */
  errors[INLINE_ERRORS].push((noValue && !optional) ? 'Please enter text' : null);
  errors[INLINE_ERRORS].push((overCharacterLimit) ? 'Text exceeds character limit' : null);
  errors[INLINE_ERRORS].push((underCharacterMin && !noValue) ? 'Text has too few characters' : null);
  // errors[INLINE_ERRORS].push((hasSpecialCharacter) ? 'Special character < cannot be accepted in Ace' : null);


  /* REMOVE BLANK ERRORS (because Formik gets confused) */
  return cleanUpFieldErrors(errors);
};

const peerRejectionReason = {
  id: fieldId,
  validator,
  initialValues,
  vFParams,
  fieldType: VF_TEXTAREA,
};

export { peerRejectionReason };
